(function () {
    var key = 'fauxScroll:' + window.location.pathname;
    try {
      var savedY = sessionStorage.getItem(key);
      console.log('[FauxNav] Restore check', { key: key, savedY: savedY });
      if (savedY === null) return;
  
      var targetY = parseInt(savedY, 10) || 0;
      try {
        history.scrollRestoration = 'manual';
      } catch (e) {}
  
      // Hide the page to prevent top flash while we restore as early as possible
      document.documentElement.style.visibility = 'hidden';
      var revealed = false;
      var reveal = function () {
        if (revealed) return;
        revealed = true;
        document.documentElement.style.visibility = '';
      };
  
      // Try to restore as soon as there is enough content to scroll to targetY
      var startEarly = function () {
        var attempts = 0;
        var maxAttempts = 60; // ~1s at 60fps
        function tryScroll() {
          var bodyHeight = document.body ? document.body.scrollHeight : 0;
          if (bodyHeight >= targetY + 1 || attempts >= maxAttempts) {
            try {
              console.log('[FauxNav] rAF restore to y=', targetY, 'attempt=', attempts);
              window.scrollTo({ top: targetY, behavior: 'instant' });
            } catch (e) {
              console.warn('[FauxNav] scrollTo failed in rAF', e);
            }
            reveal();
            try {
              sessionStorage.removeItem(key);
              console.log('[FauxNav] Cleared key', key);
            } catch (e) {
              console.warn('[FauxNav] Failed to clear key', key, e);
            }
          } else {
            attempts++;
            requestAnimationFrame(tryScroll);
          }
        }
        requestAnimationFrame(tryScroll);
      };
  
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startEarly);
      } else {
        startEarly();
      }
  
      // Fallback: ensure correct position at load if we didn't reveal yet
      window.addEventListener('load', function () {
        if (revealed) return;
        console.log('[FauxNav] Load fallback restore to y=', targetY);
        try {
          window.scrollTo({ top: targetY, behavior: 'instant' });
        } catch (e) {}
        reveal();
        try {
          sessionStorage.removeItem(key);
        } catch (e) {}
      });
  
      // Safety: unhide even if nothing fired quickly
      setTimeout(function () {
        if (revealed) return;
        console.warn('[FauxNav] Safety reveal fired');
        try {
          window.scrollTo({ top: targetY, behavior: 'instant' });
        } catch (e) {}
        reveal();
        try {
          sessionStorage.removeItem(key);
        } catch (e) {}
      }, 1500);
    } catch (e) {
      console.warn('[FauxNav] sessionStorage or setup unavailable', e);
    }
  })();